import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./PayTrack.scss";
import Details from "./Details";
import Person from "./Person";
import Transaction from "./Transaction";
import Loader from "utilities/Loader";
import { getFactorDetail, getOrders, getTransactions } from "../services/payTrack";

const PayTrack = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [remaining, setRemaining] = useState(0);
  const [factorDetails, setFactorDetails] = useState({
    type: 0,
    date: "",
    main_status: 0,
    pay_state: 0,
  });
  const [orders, setOrders] = useState([
    {
      title: "",
      total_count: 0,
      total_discount: 0,
      total_amt: 0,
      total_paid: 0,
      passangers: [{ id: -1, fname: "", lname: "", mobile: "" }],
    },
  ]);
  const [transactions, setTransactions] = useState([
    {
      amount: 0,
      date: "",
      main_status: 0,
    },
  ]);
  const [num, setNum] = useState(0);

  const main_status = () => {
    switch (factorDetails.main_status) {
      case 0:
        return "ثبت شده";
      case 1:
        return "لغو شده";
      case 2:
        return "پرداخت شده";
      default:
        return "NaN";
    }
  };

  const pay_state = () => {
    switch (factorDetails.pay_state) {
      case 0:
        return "بدهکار";
      case 1:
        return "تسویه شده";
      default:
        return "NaN";
    }
  };

  const type = () => {
    switch (factorDetails.type) {
      case 0:
        return "رزرو تور";
      case 1:
        return "سفارش محصول";
      case 2:
        return "بلیط";
      default:
        return "NaN";
    }
  };

  useEffect(() => {
    setRemaining(orders[0].total_amt - orders[0].total_discount - orders[0].total_paid);
  }, [orders]);

  const { id } = useParams();
  useEffect(() => {
    async function loadPage() {
      if (id.toString().length <= 13) {
        history.push("/");
        return "";
      }
      let x = parseInt(id.slice(13)) / 2;
      setNum(x);

      let resFactor = await getFactorDetail(x);
      if (!resFactor) {
        history.push("/");
        return "";
      }
      setFactorDetails(resFactor);

      let resOrders = await getOrders(x);
      setOrders(resOrders);

      let resTransactions = await getTransactions(x);
      setTransactions(resTransactions);
      setLoading(false);
    }
    loadPage();
  }, []);
  return (
    <div dir="rtl" className="row flex-column align-items-center pay-track">
      {loading ? <Loader /> : ""}
      <div className="flex-column align-items-center col-12 col-sm-10 col-lg-8 col-xl-10">
        <div className="headers">وضعیت سفارش</div>
        <div className="tables" style={{ textAlign: "right" }}>
          <div className="headers_table hbase">
            <div className="row justify-content-start">
              <div className="item col-12 col-lg-4 ">
                شماره فاکتور :<span className="itemValue"> {num}</span>
              </div>
              <div className="item col-12 col-lg-4 ">
                نوع : <span className="itemValue"> {type()}</span>
              </div>
              <div className="item col-12 col-lg-4 ">
                زمان سفارش :<span className="itemValue"> {factorDetails.date}</span>
              </div>
              <div className="item col-12 col-lg-4 ">
                آخرین وضعیت :<span className="itemValue"> {main_status()}</span>
              </div>
              <div className="item col-12 col-lg-4 ">
                وضعیت پرداخت :<span className="itemValue"> {pay_state()}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-column align-items-center col-12 col-sm-10 col-lg-8 col-xl-10">
        <div className="headers">جزئیات خرید</div>
        <div className="details box-shadow">
          <div className="tables">
            <div className="headers_table d-lg-flex d-none">
              <div className="item col-3">عنوان</div>
              <div className="item col-3">تعداد</div>
              <div className="item col-3"> مجموع تخفیفات</div>
              <div className="item col-3">مبلغ کل</div>
            </div>
            {<Details orders={orders} />}
            <div className="headers_table inside d-lg-flex d-none">
              <div className="item col-6">نام و نام خانوادگی</div>
              <div className="item col-6">شماره تماس</div>
            </div>
            {<Person person={orders[0].passangers} />}
          </div>
        </div>
      </div>
      <div className="flex-column align-items-center col-12 col-sm-10 col-lg-8 col-xl-10">
        <div className="headers">تراکنش ها</div>
        <div className="details box-shadow">
          <div className="tables">
            <div className="headers_table d-lg-flex d-none">
              <div className="item col-4">مبلغ</div>
              <div className="item col-4">زمان</div>
              <div className="item col-4">وضعیت</div>
            </div>
            {<Transaction transactions={transactions} />}
          </div>
        </div>
      </div>

      <div className="flex-column align-items-center col-12 col-sm-10 col-lg-8 col-xl-10">
        <div className="footer row tables justify-content-md-end justify-content-center">
          <div className="item remain m-2">مانده سفارش : {remaining}</div>
          <button className="btn btn-primary m-2" type="button" disabled={remaining == 0}>
            پرداخت نهایی
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayTrack;
